import { initialState } from './initialState';
export default function (state = initialState, action = {}) {
  switch (action.type) {
    case 'SURVEY_FINISHED_LOADING':
      return {
        ...state,
        isLoading: true,
        success: false,
        error: false,
      };

    case 'SURVEY_FINISHED_SUCCESS':
      return {
        ...state,
        isLoading: false,
        success: true,
        finished_survey_data: action.payload.data,
        error: false,
      };

    case 'SURVEY_FINISHED_ERROR':
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload.response ? action.payload.response.data : action.payload.data,
      };

      case 'GET_OPPORTUNITY_LOADING':
      return {
        ...state,
        isLoading: true,
        success: false,
        error: false,
      };

    case 'GET_OPPORTUNITY_SUCCESS':
      return {
        ...state,
        isLoading: false,
        success: true,
        opportunity_list: action.payload.data,
        error: false,
      };

    case 'GET_OPPORTUNITY_ERROR':
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload.response ? action.payload.response.data : action.payload.data,
      };
   
    default:
      return {
        ...state,
      };
  }



}
